// componentes/NotFound.js
import React from 'react';

const RutaNoEncontrada = () => {
  return (
    <div>
      <h1>404</h1>
      <p>La página que buscas no existe</p>
    </div>
  );
};

export default RutaNoEncontrada;
